var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SearchAutocomplete',{on:{"updatelonlat":_vm.updatelonlat,"updateeredmeny":_vm.updateeredmeny}}),_vm._v(" "),_c('l-circle-marker',{attrs:{"lat-lng":_vm.center,"radius":50,"color":"red"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }